// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_2FP1n","fakta":"_25l70"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Page/PageComponents/Fakta/Fakta.scss
 ** module id = 433
 ** module chunks = 0
 **/